import { Progress } from 'src/components/progress';

import { ProductGrid } from '../productGrid/ProductGrid';
import { ProductListProps } from './ProductList.interface';

export const ProductList = (props: ProductListProps) => {
  if (props.isLoadingInfiniteProducts) {
    return <Progress />;
  }

  return (
    <ProductGrid
      infiniteProductsData={props.infiniteProductsData}
      isLoadingInfiniteProducts={props.isLoadingInfiniteProducts}
      errorLoadingInfiniteProducts={props.errorLoadingInfiniteProducts}
      onSortChangeHandle={props.onSortChangeHandle}
      selectedSortOption={props.selectedSortOption}
      getNextProductPage={props.getNextProductPage}
      numResults={props.numResults}
      totalCount={props.totalCount}
      scrollRef={props.scrollRef}
    />
  );
};
